import React, { useState, useEffect, useRef } from "react";
import Dropdown from "./Dropdown";
import Swal from "sweetalert2";
// import FormInputs from "../StudentRegistration/FormInputs";
import FormInputs from "./FormInputs";
import { fetchCourseData } from "../../Redux/StudentRegistration/courseSlice";
import "./scheduletest.css";
import { useDispatch, useSelector } from "react-redux";
import { FULL_API_BASE_URL } from "../../Config/Config";

function GenerateResult(dataClient) {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [courseOpted, setCourseOpted] = useState("");
  const [batchDataByCourseID, setBatchDataByCourseID] = useState("");
  const [testSeriesData, setTestSeriesData] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [assessments, setAssessments] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const filterRef = useRef(null);
  const [values, setValues] = useState({
    course_id: "",
    testseries_id: "",
    // batch_id: "",
    // start_time: "",
    // end_time: "",
  });

  const [isChecked, setIsChecked] = useState(true);
  const clientBranchId =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
  const userName = dataClient.dataClient?.client_schema_name[6][0].user_name;
  const assessment_type_id = 2;
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // const handleCheckboxChange = () => {
  //   setIsChecked(!isChecked);
  // };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setSearchKey("");
    dispatch(fetchCourseData());
    // Reset start_time and end_time when courseOpted changes
    setValues((prevValues) => ({
      ...prevValues,
      start_time: "",
      end_time: "",
    }));
  }, [courseOpted, dispatch]);

  useEffect(() => {
    const fetchBatchData = async () => {
      if (courseOpted) {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-batch-name-by-course-id/?course_id=${courseOpted}`
        );
        const data = await response.json();
        setBatchDataByCourseID(data);
      }
    };
    fetchBatchData();
  }, [courseOpted]);

  useEffect(() => {
    setSearchKey("");
    const fetchTestData = async () => {
      if (courseOpted) {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-test-series-list-active/?course_id=${courseOpted}`
        );
        const data = await response.json();
        setTestSeriesData(data);
      }
    };
    fetchTestData();
  }, [courseOpted]);

  useEffect(() => {
    if (searchKey.trim().length === 0) {
      setAssessments([]);
    } else {
      fetchData();
    }
  }, [searchKey]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setAssessments([]);
    }
  };

  const fetchData = async () => {
    const response = await fetch(
      `${FULL_API_BASE_URL}/get-assessment-names/?assessment_type_id=${assessment_type_id}&course_id=${values.course_id}&client_branch_id=${clientBranchId}&search_key=${searchKey}`
    );
    const data = await response.json();

    if (data.data && data.data.length > 0) {
      setAssessments(data.data);
      console.log("assessments", assessments);
    } else {
      setAssessments([]);
      if (!isInitialLoad) {
        console.log("No tests found for the selected course and test series.");
      }
    }
    setIsInitialLoad(false);
  };

  const handleChange = (e) => {
    setSearchKey(e.target.value);
  };

  const handleAssessmentClick = (item) => {
    setSelectedAssessment(item);
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    });
  };

  const handleGenerate = async () => {
    const { batch_id, start_time, end_time } = values;

    // if (!selectedAssessment || !batch_id || !start_time || !end_time) {
    if (!selectedAssessment) {
      Swal.fire({
        title: "Error",
        text: "Please select test for generating result.",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    console.log("selectedAssessment", selectedAssessment);
    console.log("dataClient", userName);

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/generate-report-card-v2/?assessment_assignment_id=${selectedAssessment.assignment_id}&username=${userName}`,
        {
          method: "GET",
        }
      );
      const result = await response.json();
      if (result.message === "Report card generation completed") {
        Swal.fire({
          title: "Success",
          text: "Generated result successfully",
          icon: "success",
          confirmButtonColor: "rgb(100 101 101)",
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        throw new Error(result.message || "Error generating result");
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `Error generating result: ${error.message}`,
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
    }
  };

  // const handleStartTimeChange = (e) => {
  //   const startTime = e.target.value;
  //   setValues((prevValues) => ({
  //     ...prevValues,
  //     start_time: startTime,
  //   }));

  //   if (selectedAssessment && selectedAssessment.duration_mins) {
  //     const duration = selectedAssessment.duration_mins * 60 * 1000; // duration in milliseconds
  //     const startDate = new Date(startTime);

  //     // Calculate the end date in UTC
  //     const endDateUTC = new Date(startDate.getTime() + duration);

  //     // Convert the end date to IST
  //     const ISTOffset = 5 * 60 * 60 * 1000 + 30 * 60 * 1000; // IST offset is +5:30
  //     const endDateIST = new Date(endDateUTC.getTime() + ISTOffset);

  //     // Format end date to 'YYYY-MM-DDTHH:MM' in IST
  //     const formattedEndDateIST = endDateIST.toISOString().slice(0, 16);
  //     setValues((prevValues) => ({
  //       ...prevValues,
  //       end_time: formattedEndDateIST,
  //     }));
  //   }
  // };

  const filteredAssessments = isChecked
    ? (assessments || []).filter(
        (assessment) => assessment.assignment_id !== null
      )
    : [];

  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Generate Result</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleGenerate}>
            GENERATE
          </button>
        </div>
      </div>
      <div className="personal-info">
        <div className="personal-header">
          <div className="header">
            <label>search test</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordion}>
            {isOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpen && (
          <div className="accordion-content">
            <div className="select-assign-test-container">
              <div className="grid-container-asssing-test">
                <div className="item1">
                  <Dropdown
                    label="Course"
                    setSelected={(selectedOption) => {
                      setCourseOpted(selectedOption);
                      setValues((prevValues) => ({
                        ...prevValues,
                        course_id: selectedOption,
                        testseries_id: "",
                        batch_id: "",
                      }));
                    }}
                    options={
                      coursesdata
                        ? coursesdata.map((course) => ({
                            label: course.course_description,
                            id: course.course_id,
                          }))
                        : ""
                    }
                  />
                </div>
                <div className="item2">
                  <Dropdown
                    key={`testseries-dropdown-${values.course_id}`}
                    label="Test Series"
                    setSelected={(selectedOption) =>
                      setValues({ ...values, testseries_id: selectedOption })
                    }
                    options={
                      testSeriesData && testSeriesData.test_series
                        ? testSeriesData.test_series.map((series) => ({
                            label: series.ts_name,
                            id: series.ts_id,
                          }))
                        : []
                    }
                    Height="auto"
                    OverFlow="auto"
                    minheight="300px"
                  />
                </div>
              </div>
            </div>
            <div className="filter-with-checkbox">
              <div className="filter-search-test">
                <input
                  type="text"
                  value={searchKey}
                  onChange={handleChange}
                  placeholder="Search Test"
                />
              </div>
              <div className="check-box-not-assign-test">
                <input
                  type="checkbox"
                  className="check-box-not-assing-input"
                  checked={isChecked}
                  readOnly
                  // onChange={handleCheckboxChange}
                />
                <label>Show tests that are assigned</label>
              </div>
            </div>
            <div className="assign-test-table">
              <table>
                <thead>
                  <tr>
                    <th>Test Name:</th>
                    <th>Course Name:</th>
                    <th>Subject Name:</th>
                    <th>Batch Name:</th>
                    <th>Assignment Date:</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAssessments.map((assessment, index) => (
                    <tr
                      key={index}
                      onClick={() => handleAssessmentClick(assessment)}
                      style={{
                        backgroundColor:
                          selectedAssessment &&
                          selectedAssessment.assessment_name ===
                            assessment.assessment_name
                            ? "#f0f8ff"
                            : "",
                      }}
                    >
                      <td>{assessment.assessment_name}</td>
                      <td>{assessment.course_name}</td>
                      <td>{assessment.subject_name}</td>
                      <td>{assessment.batch_name}</td>
                      <td>{assessment.assignment_date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default GenerateResult;
